import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Luogo } from "../types"
import { API_URL } from "../constants"

export function useLuoghiList(params: Record<string, string> = {}) {
  return useList<Luogo>(`${API_URL}/luoghi`, {
    query: params,
  })
}

export function useLuogo(id: number | undefined | string) {
  return useDetail<Luogo>(`${API_URL}/luoghi`, id?.toString())
}

export function useLuogoCreate() {
  return useCreate<Luogo>(`${API_URL}/luoghi`)
}

export function useLuogoUpdate() {
  return useUpdate<Luogo>(`${API_URL}/luoghi`)
}

export function useLuogoDelete() {
  return useDelete<Luogo>(`${API_URL}/luoghi`)
}